import styled from 'styled-components';

import { colors, fontSizes, spacing } from 'ui/theme';

export const SecondaryDetailWrapper = styled.li`
  color: ${colors.textPrimary};
  font-size: ${fontSizes.s14};
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};

  & svg {
    color: ${colors.textSecondary};
  }
`;
